import { Action, creator } from 'src/config/rootAction';

import { ProgramEnum } from '../../models/programs';
import {
    ChangeOptionsQuestionAnswerData,
    ChangeSingleOptionQuestionAnswerData,
    ChangeSingleValueQuestionAnswerData,
    ChangeStepsQuestionAnswerData,
    FetchSeveralProgramSurveysData,
    FetchSurveyData,
    NormalizedSeveralSurveysData,
    NormalizedSurveyData,
    SubmitProgramSurveyData,
    SubmitSeveralProgramSurveysData,
} from '../models/surveys';

export const FETCH_PROGRAM_SURVEY_REQUESTED = 'FETCH_PROGRAM_SURVEY_REQUESTED';
export type FetchProgramSurveyRequestAction = Action<
    typeof FETCH_PROGRAM_SURVEY_REQUESTED,
    FetchSurveyData
>;
export const fetchProgramSurvey = creator<FetchProgramSurveyRequestAction>(
    FETCH_PROGRAM_SURVEY_REQUESTED,
);

export const FETCH_PROGRAM_SURVEY_SUCCEEDED = 'FETCH_PROGRAM_SURVEY_SUCCEEDED';
export type FetchProgramSurveySuccessAction = Action<
    typeof FETCH_PROGRAM_SURVEY_SUCCEEDED,
    NormalizedSurveyData
>;
export const fetchProgramSurveySuccess = creator<FetchProgramSurveySuccessAction>(
    FETCH_PROGRAM_SURVEY_SUCCEEDED,
);

export const FETCH_PROGRAM_SURVEY_FAILED = 'FETCH_PROGRAM_SURVEY_FAILED';
export type FetchProgramSurveyFailAction = Action<typeof FETCH_PROGRAM_SURVEY_FAILED, ProgramEnum>;
export const fetchProgramSurveyFail = creator<FetchProgramSurveyFailAction>(
    FETCH_PROGRAM_SURVEY_FAILED,
);

export const FETCH_SEVERAL_PROGRAM_SURVEYS_REQUESTED = 'FETCH_SEVERAL_PROGRAM_SURVEYS_REQUESTED';
export type FetchSeveralProgramSurveysRequestAction = Action<
    typeof FETCH_SEVERAL_PROGRAM_SURVEYS_REQUESTED,
    FetchSeveralProgramSurveysData
>;
export const fetchSeveralProgramSurveys = creator<FetchSeveralProgramSurveysRequestAction>(
    FETCH_SEVERAL_PROGRAM_SURVEYS_REQUESTED,
);

export const FETCH_SEVERAL_PROGRAM_SURVEYS_SUCCEEDED = 'FETCH_SEVERAL_PROGRAM_SURVEYS_SUCCEEDED';
export type FetchSeveralProgramSurveysSuccessAction = Action<
    typeof FETCH_SEVERAL_PROGRAM_SURVEYS_SUCCEEDED,
    NormalizedSeveralSurveysData
>;
export const fetchSeveralProgramSurveysSuccess = creator<FetchSeveralProgramSurveysSuccessAction>(
    FETCH_SEVERAL_PROGRAM_SURVEYS_SUCCEEDED,
);

export const FETCH_SEVERAL_PROGRAM_SURVEYS_FAILED = 'FETCH_SEVERAL_PROGRAM_SURVEYS_FAILED';
export type FetchSeveralProgramSurveysFailAction = Action<
    typeof FETCH_SEVERAL_PROGRAM_SURVEYS_FAILED,
    ProgramEnum
>;
export const fetchSeveralProgramSurveysFail = creator<FetchSeveralProgramSurveysFailAction>(
    FETCH_SEVERAL_PROGRAM_SURVEYS_FAILED,
);

export const CHANGE_SINGLE_VALUE_QUESTION_ANSWER = 'CHANGE_SINGLE_VALUE_QUESTION_ANSWER';
export type ChangeSingleValueQuestionAnswerAction = Action<
    typeof CHANGE_SINGLE_VALUE_QUESTION_ANSWER,
    ChangeSingleValueQuestionAnswerData
>;
export const changeSingleValueQuestionAnswer = creator<ChangeSingleValueQuestionAnswerAction>(
    CHANGE_SINGLE_VALUE_QUESTION_ANSWER,
);

export const CHANGE_OPTIONS_QUESTION_ANSWER = 'CHANGE_OPTIONS_QUESTION_ANSWER';
export type ChangeOptionsQuestionAnswerAction = Action<
    typeof CHANGE_OPTIONS_QUESTION_ANSWER,
    ChangeOptionsQuestionAnswerData
>;
export const changeOptionsQuestionAnswer = creator<ChangeOptionsQuestionAnswerAction>(
    CHANGE_OPTIONS_QUESTION_ANSWER,
);

export const CHANGE_SINGLE_OPTION_QUESTION_ANSWER = 'CHANGE_SINGLE_OPTION_QUESTION_ANSWER';
export type ChangeSingleOptionQuestionAnswerAction = Action<
    typeof CHANGE_SINGLE_OPTION_QUESTION_ANSWER,
    ChangeSingleOptionQuestionAnswerData
>;
export const changeSingleOptionQuestionAnswer = creator<ChangeSingleOptionQuestionAnswerAction>(
    CHANGE_SINGLE_OPTION_QUESTION_ANSWER,
);

export const CHANGE_STEPS_QUESTION_ANSWER = 'CHANGE_STEPS_QUESTION_ANSWER';
export type ChangeStepsQuestionAnswerAction = Action<
    typeof CHANGE_STEPS_QUESTION_ANSWER,
    ChangeStepsQuestionAnswerData
>;
export const changeStepsQuestionAnswer = creator<ChangeStepsQuestionAnswerAction>(
    CHANGE_STEPS_QUESTION_ANSWER,
);

export const SUBMIT_PROGRAM_SURVEY_REQUESTED = 'SUBMIT_PROGRAM_SURVEY_REQUESTED';
export type SubmitProgramSurveyRequestAction = Action<
    typeof SUBMIT_PROGRAM_SURVEY_REQUESTED,
    SubmitProgramSurveyData
>;
export const submitProgramSurvey = creator<SubmitProgramSurveyRequestAction>(
    SUBMIT_PROGRAM_SURVEY_REQUESTED,
);

export const SUBMIT_PROGRAM_SURVEY_SUCCEEDED = 'SUBMIT_PROGRAM_SURVEY_SUCCEEDED';
export type SubmitProgramSurveySuccessAction = Action<typeof SUBMIT_PROGRAM_SURVEY_SUCCEEDED>;
export const submitProgramSurveySuccess = creator<SubmitProgramSurveySuccessAction>(
    SUBMIT_PROGRAM_SURVEY_SUCCEEDED,
);

export const SUBMIT_PROGRAM_SURVEY_FAILED = 'SUBMIT_PROGRAM_SURVEY_FAILED';
export type SubmitProgramSurveyFailAction = Action<typeof SUBMIT_PROGRAM_SURVEY_FAILED>;
export const submitProgramSurveyFail = creator<SubmitProgramSurveyFailAction>(
    SUBMIT_PROGRAM_SURVEY_FAILED,
);

export const SUBMIT_SEVERAL_PROGRAM_SURVEYS_REQUESTED = 'SUBMIT_SEVERAL_PROGRAM_SURVEYS_REQUESTED';
export type SubmitSeveralProgramSurveysRequestAction = Action<
    typeof SUBMIT_SEVERAL_PROGRAM_SURVEYS_REQUESTED,
    SubmitSeveralProgramSurveysData
>;
export const submitSeveralProgramSurveys = creator<SubmitSeveralProgramSurveysRequestAction>(
    SUBMIT_SEVERAL_PROGRAM_SURVEYS_REQUESTED,
);

export const SUBMIT_SEVERAL_PROGRAM_SURVEYS_SUCCEEDED = 'SUBMIT_SEVERAL_PROGRAM_SURVEYS_SUCCEEDED';
export type SubmitSeveralProgramSurveysSuccessAction = Action<
    typeof SUBMIT_SEVERAL_PROGRAM_SURVEYS_SUCCEEDED
>;
export const submitSeveralProgramSurveysSuccess = creator<SubmitSeveralProgramSurveysSuccessAction>(
    SUBMIT_SEVERAL_PROGRAM_SURVEYS_SUCCEEDED,
);

export const SUBMIT_SEVERAL_PROGRAM_SURVEY_FAILED = 'SUBMIT_SEVERAL_PROGRAM_SURVEY_FAILED';
export type SubmitSeveralProgramSurveysFailAction = Action<
    typeof SUBMIT_SEVERAL_PROGRAM_SURVEY_FAILED
>;
export const submitSeveralProgramSurveysFail = creator<SubmitSeveralProgramSurveysFailAction>(
    SUBMIT_SEVERAL_PROGRAM_SURVEY_FAILED,
);

export type SurveysAction =
    | FetchProgramSurveyRequestAction
    | FetchProgramSurveySuccessAction
    | FetchProgramSurveyFailAction
    | FetchSeveralProgramSurveysRequestAction
    | FetchSeveralProgramSurveysSuccessAction
    | FetchSeveralProgramSurveysFailAction
    | ChangeSingleValueQuestionAnswerAction
    | ChangeOptionsQuestionAnswerAction
    | ChangeSingleOptionQuestionAnswerAction
    | ChangeStepsQuestionAnswerAction
    | SubmitProgramSurveyRequestAction
    | SubmitProgramSurveyFailAction
    | SubmitProgramSurveySuccessAction
    | SubmitSeveralProgramSurveysRequestAction
    | SubmitSeveralProgramSurveysSuccessAction
    | SubmitSeveralProgramSurveysFailAction;
